<template>
  <button :disabled="disabled"
          @click="remove()"
          type="button"
          class="transparent-button">
    Delete <span v-show="request" class="inline-loader"></span>
  </button>
</template>

<script>
import modal from './../services/modal';
import interviewApi from './../api/interview';

export default {
  props: {
    route: {
      type: String,
      required: true
    },

    disabled: {
      type: Boolean,
      required: false,
      default() {
        return false;
      }
    },

    routeBack: {
      type: String,
      required: false,
    }
  },

  data() {
    return {
      request: false,
    };
  },

  methods: {
    remove() {
      if (this.disabled || this.request) return;

      modal.confirmation({
        text: 'Are you sure you want to delete interview?'
      }).then((response) => {
        if (!response.value) return;

        this.request = true;

        interviewApi
          .remove(this.route)
          .then(() => {
            toastr.success('Interview successfully deleted');

            this.request = false;

            if(this.routeBack) {
              location.href = this.routeBack;

              return;
            }

            location.reload();
          })
          .catch(() => {
            toastr.error('Something went wrong. Please try again later or contact with administrator');

            this.request = false;
          });
      });
    }
  }
};
</script>
